import React from 'react'
import { Link } from 'react-router'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import { history } from 'src/core/router'
import localstorage from 'src/helper/localstorage'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'

export default class extends React.Component {
  constructor(props) {
    super(props)
  }

  state = {
    uid: 0,
    accesstoken: '',
    lang: {},
    language: 'en'
  }

  async componentWillMount() {
    await setUidToken(this.props.location.query)
    
    setTimeout(function () {
      setDocumentTitle(`Child Safety Policy`)
    }, 1000)
    
    let { uid, accesstoken } = localstorage.get('userInfo')
    this.setState({
      uid: uid,
      accesstoken: accesstoken
    })
    
  }

  componentDidMount() {
    window.scroll(0, 0)
  }

  jump = () => {
    jumpToUser.bind(this, 433031)
  }

  render() {
    return (
      <div className="policy">
        <h1>Child Safety Policy</h1>
We prohibit users from creating, uploading or distributing content that incites the exploitation or abuse of children, including all child sexual abuse content. If you find such content on this app, please click the relevant report button so that we can find and remove it. Or contact our administrators at <span class="contact" onClick={this.jump.bind(this)}>dilidili2046@gmail.com</span><br/>
<br/>
We prohibit the use of any app that endangers children. This includes, but is not limited to, using the app to promote predatory behavior against children, such as:<br/>
<br/>
<ul>
<li>Inappropriate interaction with children (such as touching or caressing). </li>
<li>Grooming children (for example, befriending a child online for the purpose of having sexual contact with the child online or offline and/or exchanging sexually explicit photos with the child). </li>
<li>Sexualization of minors (for example, images that depict, encourage or promote the sexual abuse of children, or content that depicts children in a way that may lead to their sexual exploitation). </li>
<li>Sextortion (for example, threatening or blackmailing a child with real or alleged intimate photos of a child). </li>
<li>Trafficking of children (e.g., promoting or grooming children for commercial sexual exploitation purposes). </li>
<li>We will take action if we find apps containing child sexual abuse content. If you believe a child is at risk or being abused, exploited, or trafficked, please contact our administrators at dilidili2046@gmail.com</li>
</ul><br/>
We also do not allow mature themes in child-directed apps, including but not limited to: <br/>
<ul>
  <li>Contains excessive violence and gore. </li>
  <li>Depicts or encourages harmful or dangerous activities. </li>
  <li>We also do not allow apps that promote negative body or self-image, including the depiction of plastic surgery, weight loss, and other cosmetic adjustments to one's appearance for entertainment purposes. </li>
</ul>
<br/>
Contact to report child safety issues: <span class="contact" onClick={this.jump.bind(this)}>dilidili2046@gmail.com</span>
<br/>
<br/>
       </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/child_safety_policy_voca/index.js